import Loadable from 'components/Loadable';
import { ROLES } from 'models/Roles';
import { IRoute } from 'models/route';
import { lazy } from 'react';

const ListMails = Loadable(lazy(() => import('modules/Mail/pages/ListMails')));
const AddMail = Loadable(lazy(() => import('modules/Mail/pages/AddMail')));

const UpdateMail = Loadable(
	lazy(() => import('modules/Mail/pages/UpdateMail')),
);

const MAILS_ROUTES: IRoute[] = [
	{
		path: 'mails',
		element: ListMails,
		name: 'Mails',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'mails/add',
		element: AddMail,
		name: 'Add Mail',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'mails/update/:mailId',
		element: UpdateMail,
		name: 'Add Mail',
		roles: [ROLES.ADMIN],
		private: true,
	},
];

export default MAILS_ROUTES;
